
/*eslint-disable*/
import React from "react";
// react library for routing
import {Link} from "react-router-dom";
// reactstrap components
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Collapse,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    Container,
    Card,
    CardHeader,
    CardBody,
    ListGroup,
    ListGroupItem,
    Carousel,
    CarouselIndicators,
    CarouselItem,
    CarouselCaption, CarouselControl, Modal, CardTitle, CardText
} from 'reactstrap';
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.jsx";
import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
import ContentService from "../services/xgContentService";
import _ from "lodash";
import CompaniesCarousel from "./CompaniesCarousel";
import {countries} from "../util/countries";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {services} from "../util/services";
import NotificationAlert from "react-notification-alert";
import {deliveryPeriods} from "../util/deliveryPeriods";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import FormInput from "../components/common/form/FormInput";
import ContactUsService from "../services/contactUsService";
import {Helmet} from "react-helmet";
import CardFooter from "reactstrap/es/CardFooter";
import AppNavBar from "./AppNavBar";
import ReviewService from "../services/reviewService";
import DownloadUtil from "../util/downloadUtil";
import Rating from "react-rating";
import Paginations from "./Paginations";
import PricingComponent from "./pricingXaregrowth/PricingComponent";

class AboutUs  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            contentData: {},
            completeContentList: [],
            searchList: [],
            loginModal: false,
            currentPage: 1,
            pageSize: 9, // 8 items to display 4 per row (2 rows per page)
        };
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        ReviewService.partnersData().then((response) => {
            console.log(response);
            this.setState({completeContentList: response});
            this.setState({searchList: response});
        });
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    renderCards(items) {
        let obj = this;
        return (
            <Container className="mt-4 mb-4">
                <Row className="gx-4 gy-4 justify-content-center">
                    {items.map((item) => (
                        <Col key={UtilService.uuidv4()} xs="12" sm="6" md="4" lg="3">
                            <div
                                onClick={() => {
                                    obj.props.history.push(`/company/${item.companyId}`);
                                }}
                                className="p-3 rounded shadow-sm h-100"
                                style={{
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #e7eaf0",
                                    cursor: "pointer",
                                    transition: "transform 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.09)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                }}
                            >
                                {/* Image on top */}
                                <div className="text-left mb-2">
                                    <img
                                        src={
                                            item.brandLogoUID === null
                                                ? require("assets/img/brand/companies.jpeg")
                                                : DownloadUtil.generateUrl(item.brandLogoUID)
                                        }
                                        alt="Company Logo"
                                        style={{
                                            width: "50%",
                                            height: "60&",
                                            objectFit: "contain",
                                            borderRadius: "4px",
                                        }}
                                    />
                                </div>

                                {/* Text content below */}
                                <div className="text-left">
                                    <h5 className="font-weight-bold text-dark">{item.companyName}</h5>
                                    <div className="">
                                        <Rating
                                            readonly
                                            initialRating={item.score}
                                            emptySymbol={<i className="fa fa-star text-muted"/>}
                                            fullSymbol={<i className="fa fa-star text-warning"/>}
                                            fractions={2}
                                            title={item.score?.toFixed(1)}
                                        />
                                        &nbsp;
                                        <span className=" text-muted" style={{fontSize: "0.9rem"}}>
                                            {item.score?.toFixed(1) ?? "0.0"}
                                        </span>
                                        &nbsp;
                                        <span className="text-muted" style={{fontSize: "0.85rem"}}>
                                            ({item?.scoreBreakdown?.totalReviews || 0})
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        );
    }



    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };



    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        const {completeContentList, currentPage, pageSize, searchList} = this.state;
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedItems = searchList.slice(startIndex, startIndex + pageSize);
        return (
            <div style={{backgroundColor: "white"}}>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>International Expansion</p>
                                    <h1 style={{textAlign: "start"}}>Helping SMEs grow</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>
                <Container className="my-5">
                    <Row>
                        <Col md="12" lg="12" className="mb-4" style={{ display: "block" }}>
                            <Card className="h-100 shadow-sm border-0">
                                <CardHeader>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={11}>
                                            <CardTitle tag="h1" style={{marginBottom: 'initial',
                                                borderBottom: '4px solid red',
                                                display: 'inline-block', // required for underline to size correctly
                                                paddingBottom: '0px',// optional spacing
                                            }}>About Us</CardTitle>

                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Container className="mt-10" style={{backgroundColor: "white"}}>
                                        <Row>
                                            <Col sm={"12"} md={"6"}>
                                                <Card style={{backgroundColor: "transparent", boxShadow: "none", }}>
                                                    <CardBody style={{backgroundColor: "transparent"}}>
                                                        <br/>
                                                        <br/>
                                                        <br/>
                                                        <br/>
                                                        <div className="card-profile-image">
                                                            <a href="#pablo" onClick={e => e.preventDefault()}>
                                                                <img
                                                                    style={{maxWidth: "300px", left: "35%", top: "100%"}}
                                                                    alt="..."
                                                                    className="rounded-circle"
                                                                    src={require("assets/img/brand/asier.png")}
                                                                />
                                                                <br/>
                                                                <br/>
                                                                <br/>
                                                                <br/>
                                                            </a>
                                                        </div>
                                                    </CardBody>
                                                    <br/>
                                                    <CardFooter style={{border : "none", marginTop:"40%"}}>
                                                        <h2 style={{marginLeft: "25%", marginTop: "-20%"}}
                                                            className="justify-content-center">Asier Sinde  &nbsp;
                                                            <a
                                                                className="fab fa-linkedin"
                                                                href="https://www.linkedin.com/in/asier-sinde-292a3b7/"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                            </a>
                                                        </h2>
                                                        <h4 style={{marginLeft: "25%"}}
                                                            className="justify-content-center">Founder</h4>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                            <Col sm={"12"} md={"6"}>
                                                <br/>
                                                <br/>
                                                <h1>Xaregrowth is a platform committed to helping start-ups and SMEs grow their business,
                                                    especially in international markets.
                                                </h1>
                                                <br/>
                                                <h3>We believe in the importance of SMEs in the economic development of communities around
                                                    the world, helping more families put food on the table and more children in schools.
                                                </h3>
                                                <br/>
                                                <h3>To achieve our mission, Xaregrowth leverages technology and global networks to give SMEs
                                                    access to the support they require at affordable rates.
                                                </h3>
                                                <br/>
                                                <h3>If you give us the opportunity, we would love to be part of your growth journey.</h3>
                                            </Col>
                                        </Row>
                                    </Container>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                { paginatedItems.length > 0  && <Container className="my-5">
                    <Row>
                        <Col md="12" lg="12" className="mb-4" style={{ display: "block" }}>
                            <Card className="h-100 shadow-sm border-0">
                                <CardHeader>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={11}>
                                            <CardTitle tag="h1" style={{marginBottom: 'initial',
                                                borderBottom: '4px solid red',
                                                display: 'inline-block', // required for underline to size correctly
                                                paddingBottom: '0px',// optional spacing
                                            }}>Our Partners</CardTitle>

                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Container>
                                        {paginatedItems.length > 0 ?
                                            <>
                                                {this.renderCards(paginatedItems)}
                                                <Paginations
                                                    totalItems={completeContentList.length}
                                                    pageSize={pageSize}
                                                    currentPage={currentPage}
                                                    onPageChange={this.onPageChange}
                                                />
                                                {/*<ReviewCompaniesCarousel companies={completeContentList}/>*/}
                                            </> : (<h1></h1>)}


                                    </Container>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                }



                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default AboutUs;
